export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'tech', name: '科技数码', icon: 'ri-computer-line' },
  { slug: 'lifestyle', name: '生活娱乐', icon: 'ri-heart-line' },
  { slug: 'education', name: '教育学习', icon: 'ri-book-open-line' },
  { slug: 'finance', name: '财经商业', icon: 'ri-line-chart-line' },
  { slug: 'health', name: '健康养生', icon: 'ri-mental-health-line' },
  { slug: 'travel', name: '旅游出行', icon: 'ri-flight-takeoff-line' },
  { slug: 'sports', name: '体育运动', icon: 'ri-basketball-line' },
];

export const articles = [
  {
    id: 1,
    slug: 'ai-changing-future-2026',
    title: '2026年人工智能如何改变我们的日常生活',
    excerpt: '从智能家居到自动驾驶，人工智能正在以惊人的速度融入我们的日常生活。本文将深入探讨AI技术在2026年的最新应用场景和发展趋势。',
    content: `<p>人工智能技术的飞速发展正在重塑我们的世界。2026年，AI已经不再是一个遥远的概念，而是实实在在地融入了日常生活的方方面面。</p>
    <h2>智能家居的新纪元</h2>
    <p>现代智能家居系统已经能够通过学习用户的行为模式，自动调节室内温度、照明和安防系统。最新的AI助手不仅能够理解自然语言指令，还能根据用户的情绪状态主动提供建议。</p>
    <p>数据显示，2026年全球智能家居市场规模已突破5000亿美元，超过65%的城市家庭至少拥有一款AI驱动的智能设备。</p>
    <h2>自动驾驶的普及</h2>
    <p>L4级别的自动驾驶汽车已在多个城市投入商用，大大降低了交通事故率。AI算法能够实时处理来自激光雷达、摄像头和超声波传感器的海量数据，在毫秒级别做出安全决策。</p>
    <h2>医疗健康的革命</h2>
    <p>AI辅助诊断系统在医学影像分析方面的准确率已超过资深医生。通过深度学习模型，系统能够在CT扫描和MRI图像中检测出微小的病变，为早期治疗提供了宝贵的时间窗口。</p>
    <h2>教育的个性化</h2>
    <p>自适应学习平台利用AI技术，为每个学生量身定制学习路径。系统能够实时分析学生的学习习惯、强项和薄弱环节，动态调整教学内容和难度。</p>
    <h2>未来的展望</h2>
    <p>随着量子计算和神经形态芯片的发展，AI的能力边界将进一步扩展。专家预测，到2030年，通用人工智能将在特定领域展现出超越人类的能力。</p>`,
    category: 'tech',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20artificial%20intelligence%20concept%20with%20holographic%20displays%20and%20neural%20network%20visualization%20in%20a%20minimalist%20modern%20setting%20with%20warm%20amber%20and%20teal%20accents%20clean%20composition%20professional%20style&width=800&height=500&seq=article-ai-2026&orientation=landscape',
    author: '张明远',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['人工智能', '科技', '未来趋势'],
  },
  {
    id: 2,
    slug: 'remote-work-best-practices',
    title: '远程办公效率提升的10个实用技巧',
    excerpt: '远程办公已成为新常态，但如何在灵活工作的同时保持高效产出？本文分享10个经过验证的实用技巧，帮助你在远程办公中游刃有余。',
    content: `<p>随着远程办公模式的普及，越来越多的人开始探索如何在家庭环境中保持高效工作。本文将分享经过实践验证的10个核心技巧。</p>
    <h2>打造专属工作空间</h2>
    <p>一个专门的工作区域能够帮助大脑建立"工作模式"的条件反射。即使是客厅的一个角落，也应该布置得专业且舒适。良好的照明、符合人体工学的座椅以及整洁的桌面是基础配置。</p>
    <h2>建立固定的作息时间</h2>
    <p>远程办公最大的挑战之一是工作与生活的界限模糊。设定固定的开始和结束工作时间，并严格遵守，能够有效避免过度工作或拖延症。</p>
    <h2>使用番茄工作法</h2>
    <p>将工作时间分割为25分钟专注时段和5分钟休息时段，能够显著提升专注力和产出质量。每完成四个番茄钟后，安排一个较长的休息时间。</p>
    <h2>善用协作工具</h2>
    <p>选择适合团队的协作工具至关重要。从即时通讯到项目管理，从文档协作到视频会议，合理搭配工具能够大幅提升远程协作效率。</p>`,
    category: 'lifestyle',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20home%20office%20setup%20with%20laptop%20on%20wooden%20desk%20natural%20light%20from%20window%20cozy%20atmosphere%20with%20plants%20warm%20neutral%20tones%20professional%20photography&width=800&height=500&seq=article-remote&orientation=landscape',
    author: '李思涵',
    date: '2026-07-25',
    readTime: '6分钟',
    tags: ['远程办公', '效率提升', '生活方式'],
  },
  {
    id: 3,
    slug: 'blockchain-web3-revolution',
    title: '区块链与Web3：下一代互联网的基石',
    excerpt: 'Web3技术正在重新定义互联网的运作方式，区块链作为其底层技术，正引领着一场去中心化的革命。了解Web3如何改变数据所有权和数字身份。',
    content: `<p>Web3代表着互联网的下一个演进阶段，其核心理念是去中心化和用户数据主权。区块链技术作为Web3的基石，正在重塑数字世界的运作规则。</p>
    <h2>什么是Web3</h2>
    <p>与Web2.0由少数科技巨头控制的中心化模式不同，Web3致力于将数据所有权和控制权归还给用户。通过区块链技术，用户可以在无需信任第三方的情况下进行价值交换和数据管理。</p>
    <h2>去中心化金融</h2>
    <p>DeFi（去中心化金融）是Web3最成熟的应用领域之一。智能合约使得借贷、交易和保险等金融服务能够在没有中介的情况下自动执行，降低了成本并提高了效率。</p>
    <h2>数字身份与数据主权</h2>
    <p>在Web3世界中，用户拥有自己的数字身份和数据。通过去中心化标识符和可验证凭证，用户可以选择性地共享个人信息，同时保持对数据的完全控制。</p>
    <h2>未来展望</h2>
    <p>随着Layer 2扩容方案和跨链技术的发展，Web3的用户体验正在快速改善。预计到2028年，Web3应用将覆盖超过10亿用户。</p>`,
    category: 'tech',
    image: 'https://readdy.ai/api/search-image?query=abstract%20blockchain%20visualization%20with%20glowing%20interconnected%20nodes%20and%20geometric%20patterns%20minimalist%20dark%20background%20with%20warm%20amber%20and%20teal%20highlights%20futuristic%20yet%20elegant&width=800&height=500&seq=article-blockchain&orientation=landscape',
    author: '王浩然',
    date: '2026-07-22',
    readTime: '7分钟',
    tags: ['区块链', 'Web3', '去中心化'],
  },
  {
    id: 4,
    slug: 'financial-planning-guide-2026',
    title: '2026年个人理财规划全攻略',
    excerpt: '在经济环境不断变化的今天，科学的个人理财规划显得尤为重要。本文从收入管理、投资策略到风险控制，全方位解析2026年的理财之道。',
    content: `<p>合理的财务规划是实现人生目标的基础。2026年的经济环境充满机遇与挑战，制定科学的理财策略至关重要。</p>
    <h2>建立紧急备用金</h2>
    <p>专家建议每个家庭应储备3-6个月的生活开支作为紧急备用金。这笔资金应存放在流动性好、风险低的产品中，如货币基金或短期定期存款。</p>
    <h2>多元化投资组合</h2>
    <p>不要将所有鸡蛋放在一个篮子里。合理的资产配置应包括股票、债券、基金、黄金和不动产等多种类别，以分散风险并优化收益。</p>
    <h2>保险保障的规划</h2>
    <p>保险是财务安全的最后一道防线。根据个人情况配置适当的寿险、医疗险和意外险，能在关键时刻发挥重要作用。</p>
    <h2>退休规划要趁早</h2>
    <p>复利的力量在于时间。越早开始为退休储蓄，所需投入的资金越少。利用税收优惠的退休账户，最大化长期收益。</p>`,
    category: 'finance',
    image: 'https://readdy.ai/api/search-image?query=modern%20financial%20planning%20concept%20with%20clean%20desk%20setting%20calculator%20charts%20and%20notebook%20minimalist%20warm%20lighting%20professional%20atmosphere%20elegant%20composition&width=800&height=500&seq=article-finance&orientation=landscape',
    author: '陈雅文',
    date: '2026-07-18',
    readTime: '9分钟',
    tags: ['理财', '投资', '财务规划'],
  },
  {
    id: 5,
    slug: 'healthy-eating-guide',
    title: '科学饮食指南：打造健康生活方式',
    excerpt: '饮食是健康的基础。本文基于最新营养学研究，为你提供科学、实用的饮食建议，帮助你建立健康的饮食习惯，提升整体生活质量。',
    content: `<p>健康的饮食习惯是维持身体机能和预防疾病的关键。基于最新的营养科学研究，本文将为您提供全面的饮食指南。</p>
    <h2>均衡营养的核心原则</h2>
    <p>每天的饮食应包含五大类食物：谷物、蛋白质、蔬菜水果、乳制品和健康脂肪。建议采用"餐盘法则"：餐盘的一半为蔬菜水果，四分之一为全谷物，四分之一为优质蛋白。</p>
    <h2>减少加工食品摄入</h2>
    <p>加工食品通常含有大量的添加糖、钠和不健康脂肪。尽量选择天然、完整的食材，减少包装食品和快餐的消费频率。</p>
    <h2>水分摄入的重要性</h2>
    <p>成年人每天应饮用1.5-2升水。充足的水分摄入有助于新陈代谢、毒素排出和皮肤健康。建议在餐前饮水，既能补充水分又有助于控制食量。</p>
    <h2>规律进餐的习惯</h2>
    <p>保持规律的进餐时间有助于维持血糖稳定和新陈代谢正常。建议每天三餐定时定量，避免暴饮暴食或长时间饥饿。</p>`,
    category: 'health',
    image: 'https://readdy.ai/api/search-image?query=fresh%20healthy%20food%20arrangement%20with%20colorful%20vegetables%20fruits%20and%20whole%20grains%20on%20a%20minimalist%20wooden%20table%20natural%20light%20clean%20composition%20warm%20earthy%20tones&width=800&height=500&seq=article-health&orientation=landscape',
    author: '林小梅',
    date: '2026-07-15',
    readTime: '7分钟',
    tags: ['健康', '饮食', '生活方式'],
  },
  {
    id: 6,
    slug: 'japan-travel-guide-2026',
    title: '2026年日本深度游攻略：避开人群的秘境之旅',
    excerpt: '厌倦了人山人海的热门景点？本文为你揭秘日本那些鲜为人知但美不胜收的隐秘目的地，带你体验真正的日本文化和自然风光。',
    content: `<p>日本是许多旅行者心中的梦想目的地。然而，随着游客数量的增加，热门景点常常人满为患。本文将带您探索那些不为人知的秘境。</p>
    <h2>四国地区的隐世之美</h2>
    <p>四国岛保留了日本最原始的自然风光和传统文化。大步危峡谷的碧绿溪流、祖谷溪的藤蔓桥，以及遍路朝圣的古道，都是远离喧嚣的绝佳去处。</p>
    <h2>北陆地区的文化之旅</h2>
    <p>金泽市被誉为"小京都"，拥有日本三大名园之一的兼六园。这里的茶屋街、武士宅邸和21世纪美术馆，展现了传统与现代的完美融合。</p>
    <h2>九州的美食与温泉</h2>
    <p>由布院的温泉街、黑川温泉的露天汤池，以及福冈的屋台美食，让九州成为温泉和美食爱好者的天堂。</p>
    <h2>出行小贴士</h2>
    <p>建议购买JR PASS铁路通票，提前预订住宿，避开日本的黄金周和盂兰盆节等旅游高峰期。学习几句基本日语会让旅行体验更加顺畅。</p>`,
    category: 'travel',
    image: 'https://readdy.ai/api/search-image?query=serene%20Japanese%20countryside%20with%20traditional%20wooden%20architecture%20and%20autumn%20foliage%20peaceful%20bamboo%20forest%20path%20minimalist%20elegant%20composition%20warm%20natural%20lighting&width=800&height=500&seq=article-japan&orientation=landscape',
    author: '赵晓峰',
    date: '2026-07-10',
    readTime: '10分钟',
    tags: ['旅游', '日本', '深度游'],
  },
  {
    id: 7,
    slug: 'online-education-transformation',
    title: '在线教育的变革：从MOOC到AI个性化学习',
    excerpt: '在线教育行业正经历前所未有的变革。从大规模开放在线课程到AI驱动的个性化学习，技术的发展正在重塑教育的形式和本质。',
    content: `<p>教育技术正在以前所未有的速度发展。从最初的录播课程到如今AI驱动的自适应学习平台，在线教育已经走过了漫长的道路。</p>
    <h2>MOOC的发展历程</h2>
    <p>大规模开放在线课程自2012年兴起以来，已经吸引了全球数亿学习者。Coursera、edX等平台与顶尖大学合作，将优质教育资源带给全世界的学习者。</p>
    <h2>AI个性化学习</h2>
    <p>基于人工智能的自适应学习系统能够根据每个学生的知识水平、学习风格和进度，动态调整教学内容和难度。这种个性化方法显著提高了学习效率。</p>
    <h2>虚拟现实与沉浸式学习</h2>
    <p>VR/AR技术为教育带来了革命性的沉浸式体验。从虚拟实验室到历史场景重现，学生能够以全新的方式理解和体验知识。</p>
    <h2>终身学习的趋势</h2>
    <p>在知识快速更新的时代，终身学习已成为必需。在线教育平台为职场人士提供了灵活、高效的技能提升途径。</p>`,
    category: 'education',
    image: 'https://readdy.ai/api/search-image?query=modern%20online%20education%20concept%20with%20digital%20learning%20interface%20floating%20screens%20and%20minimalist%20design%20warm%20lighting%20clean%20professional%20atmosphere%20inspirational&width=800&height=500&seq=article-education&orientation=landscape',
    author: '周思远',
    date: '2026-07-05',
    readTime: '7分钟',
    tags: ['在线教育', 'AI学习', '教育科技'],
  },
  {
    id: 8,
    slug: 'marathon-training-guide',
    title: '从零到全马：马拉松训练完整指南',
    excerpt: '马拉松不仅是对身体的挑战，更是对意志的考验。无论你是跑步新手还是有经验的跑者，这份完整的训练指南将帮助你安全、高效地备战马拉松。',
    content: `<p>完成一场全程马拉松是许多跑步爱好者的梦想。本文将为您提供从零基础到完赛的完整训练计划。</p>
    <h2>基础体能储备期</h2>
    <p>在开始马拉松专项训练前，建议先建立至少3个月的规律跑步习惯。每周跑步3-4次，累计里程达到25-30公里，确保身体已经适应跑步的负荷。</p>
    <h2>专项训练阶段</h2>
    <p>标准的马拉松训练周期为16-20周。训练内容包括轻松跑、长距离跑、间歇跑和节奏跑，每周至少安排一次力量训练以预防伤病。</p>
    <h2>营养与补给策略</h2>
    <p>长距离跑步需要科学的营养支持。训练期间注意碳水化合物的补充，比赛前3天进行碳水加载，比赛中每30-45分钟补充能量胶和电解质。</p>
    <h2>比赛日策略</h2>
    <p>合理的配速是完赛的关键。建议采用"前慢后快"的负分段策略，前21公里保持舒适配速，后半程根据状态适当加速。</p>`,
    category: 'sports',
    image: 'https://readdy.ai/api/search-image?query=runners%20on%20scenic%20marathon%20course%20during%20golden%20hour%20sunrise%20warm%20atmospheric%20light%20road%20winding%20through%20nature%20dynamic%20composition%20inspiring%20mood&width=800&height=500&seq=article-marathon&orientation=landscape',
    author: '刘健华',
    date: '2026-06-28',
    readTime: '11分钟',
    tags: ['跑步', '马拉松', '运动训练'],
  },
];

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    description: '采用先进的加密技术和多重安全防护体系，确保您的数据安全和平台稳定运行。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    description: '汇聚各领域优质内容，涵盖科技、生活、教育、财经等八大板块，持续更新。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '便捷体验',
    description: '简洁直观的界面设计，流畅的交互体验，让您随时随地畅享优质内容。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '专属权益',
    description: '会员专享精品内容、优先体验新功能、专属客服等多项特权，物超所值。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持电脑、平板、手机多端无缝切换，阅读进度和收藏内容实时同步。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '7x24小时在线客服，快速响应您的每一个需求，用心做好每一次服务。',
  },
];

export const stats = [
  { value: '500万+', label: '注册用户' },
  { value: '10万+', label: '优质文章' },
  { value: '8', label: '内容板块' },
  { value: '99.9%', label: '服务可用率' },
];

export const faqItems = [
  {
    question: '91n.com 提供哪些类型的内容？',
    answer: '91n.com 涵盖科技数码、生活娱乐、教育学习、财经商业、健康养生、旅游出行、体育运动等多个领域，为您提供丰富多样的优质内容。',
  },
  {
    question: '如何注册成为91n.com会员？',
    answer: '您只需点击页面右上角的"注册"按钮，填写基本信息并完成验证，即可免费注册成为91n.com会员，享受基础会员权益。',
  },
  {
    question: '会员有哪些专属权益？',
    answer: '会员可享受精品独家内容、无广告浏览体验、优先参与平台活动、专属客服通道、内容离线下载等多项特权。',
  },
  {
    question: '91n.com是否支持移动端访问？',
    answer: '当然支持！91n.com采用响应式设计，完美适配手机、平板和电脑等多种设备，您可以在任何设备上获得流畅的访问体验。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过"关于我们"页面的联系表单、在线客服或官方邮箱与我们取得联系，我们将在24小时内回复您的咨询。',
  },
  {
    question: '平台内容多久更新一次？',
    answer: '我们的编辑团队每天都会更新优质内容，确保您始终能够获取最新、最有价值的信息和资源。',
  },
];

export const testimonials = [
  {
    name: '王先生',
    role: '资深会员',
    content: '使用91n.com已经两年了，内容质量一直很高，分类清晰，搜索功能也很强大。会员权益确实物超所值！',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20portrait%20clean%20simple%20background%20warm%20lighting%20minimalist&width=100&height=100&seq=avatar-wang&orientation=squarish',
  },
  {
    name: '李女士',
    role: '企业用户',
    content: '作为团队学习的平台，91n.com提供了丰富的行业资讯和专业知识，帮助我们团队保持行业前沿视野。',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20portrait%20clean%20simple%20background%20warm%20lighting%20minimalist&width=100&height=100&seq=avatar-li&orientation=squarish',
  },
  {
    name: '张同学',
    role: '学生用户',
    content: '学习板块的内容对我帮助很大，从考试技巧到专业入门，应有尽有。而且界面简洁，使用体验非常好！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20student%20portrait%20clean%20simple%20background%20warm%20lighting%20minimalist&width=100&height=100&seq=avatar-zhang&orientation=squarish',
  },
];